import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';
import { IError } from '~src/httpClient/serverApi/types/IError';

import { GroupSets } from '../../GroupSets';
import { IGroupSetInfo } from '../../models/IGroupSetInfo';
import { editGroupSetDialogBodyStyles } from '../styles/EditGroupSetDialogStyles';
import { EditGroupSetNameField } from './EditGroupSetNameField';


export interface EditGroupSetDialogProps {
    readonly close: (result: any) => void;
    readonly dismiss: () => void;
    readonly groupSet: IGroupSetInfo;
}

export function EditGroupSetDialog(props: EditGroupSetDialogProps): JSX.Element {
    const [name, setName] = React.useState(props.groupSet.name);
    const [busy, setBusy] = React.useState(false);
    const [groupSetNameError, setGroupSetNameError] = React.useState(undefined);

    const updateGroupSetCallback = async () => {
        setBusy(true);
        const result = await GroupSets.updateGroupSet(props.groupSet, name);
        if(!!result.errors && result.errors.length > 0) {
            handleErrors(result.errors[0]);
        } else {
            const successMsg = Messages.editGroupSet_success({ NEW_ITEM_NAME: L10n.elideIfLong(props.groupSet.name) });
            ToasterService.instance.pop({ type: ToastType.Success, text: successMsg });
            props.close({});
        }
    };

    const handleErrors = (error: IError) => {
        const errorMsg = errorMessageFor(error.code);
        if (!errorMsg) {
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.unknownFailure() });
          props.close({});
        } else {
          setBusy(false);
          setGroupSetNameError(errorMsg);
        }
    };

    const errorMessageFor = (errorCode: number) => {
        switch (errorCode) {
          default:
            return Messages.errorGroupSetName();
        }
    };

    const canUpdateGroupSet = (): boolean => {
        return (props.groupSet.name !== name) && name.length > 0;
    };

    return (
        <div>
            <div style={editGroupSetDialogBodyStyles}>
                {<EditGroupSetNameField
                    name={name}
                    groupSetNameError={groupSetNameError}
                    setName={setName}
                    setGroupSetNameError={setGroupSetNameError}/>
                }
            </div>
            <div className="tb-dialog-actions">
                <ButtonWidget
                    buttonType={ButtonType.Outline}
                    showSpinner={busy}
                    onClick={props.dismiss}
                    testId={'confirm-action-dialog-cancel'}
                    children={Messages.cancel()}
                    disabled={busy}/>
                <span className="tb-margin-left-wide">
                    <ButtonWidget
                        buttonType={ButtonType.Primary}
                        showSpinner={busy}
                        onClick={updateGroupSetCallback}
                        testId={'confirm-action-dialog-submit'}
                        children={Messages.save()}
                        disabled={!canUpdateGroupSet()}
                    />
                </span>
            </div>
        </div>
    );
}